import React from 'react';

import { CatalogObjectDisplayObject } from '../../../../Data/CatalogObjectDisplayObject';

type StaticItemComponentParameters = {
  item : CatalogObjectDisplayObject,
  showPage : (collectionName: string, objectName: string, pageType: string) => void,
  pageType: string;
};

export function StaticItemComponent(
  {
    item,
    showPage,
    pageType,
  }: StaticItemComponentParameters,
) {

  return (
    <button
      type="button"
      className="static-item"
      style={{ width: item.width, height: item.height, border: 'none' }}
      onClick={() => {
        showPage(item.collectionName, item.name, pageType);
      }}
    >
      <img className="d-block w-100" src={item.imageURL[0]} alt={item.name} />
    </button>
  );
}
